module.exports = __webpack_public_path__ + "img/certification-origin1.d2ae9e4f.png";